import { lazy } from "react";
import authRoute from "./authRoute";
import othersRoute from "./othersRoute";
import type { Routes } from "@/@types/routes";
import appConfig from "../app.config";

export const publicRoutes: Routes = [...authRoute];

export const protectedRoutes: Routes = [
  {
    key: "home",
    path: "/home",
    component: lazy(() => import("@/views/Home")),
    authority: [],
  },
  {
    key: "ai-agent.orphan-resolution-agent",
    path: "/ai-agent/orphan-resolution-agent",
    component: lazy(() => import("@/views/ai-agents/OrphanResolutionAgent")),
    authority: [],
  },
  ...(appConfig.enableGtaAgent
    ? [
        {
          key: "ai-agent.group-termination-agent",
          path: "/ai-agent/group-termination-agent",
          component: lazy(() => import("@/views/ai-agents/GroupTerminationAgent")),
          authority: [],
        },
      ]
    : []),
  ...othersRoute,
];
